<script setup lang="ts">
import googleIcon from '@/assets/pngs/google.png'
import kakaoIcon from '@/assets/pngs/kakao.png'
import naverIcon from '@/assets/pngs/naver.png'
import { computed } from 'vue'

const props = defineProps<{
  snsType: 'NAVER' | 'KAKAO' | 'GOOGLE'
}>()

const iconWidthHeight = computed<string>(() => {
  switch (props.snsType) {
    case 'NAVER':
      return 'width: 10px; height: 9px;'
    case 'KAKAO':
      return 'width: 14px; height: 13px;'
    case 'GOOGLE':
      return 'width: 10px; height: 12px;'
    default:
      return 'width: 24px; height: 24px;'
  }
})

const iconSrc = computed<string>(() => {
  switch (props.snsType) {
    case 'NAVER':
      return naverIcon
    case 'KAKAO':
      return kakaoIcon
    case 'GOOGLE':
      return googleIcon
    default:
      return naverIcon
  }
})

const backgroundColor = computed<string>(() => {
  switch (props.snsType) {
    case 'NAVER':
      return 'background-color: #2DB400'
    case 'KAKAO':
      return 'background-color: #FEE500'
    case 'GOOGLE':
      return 'background-color: #FFFFFF'
    default:
      return 'background-color: transparent'
  }
})
</script>

<template>
  <div class="sns-icon-container" :style="backgroundColor">
    <img :src="iconSrc" :alt="snsType" :style="iconWidthHeight" />
  </div>
</template>

<style scoped>
.sns-icon-container {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
